export const periods = [
  { i18nKey: 'common:periods.today', value: 'TODAY', slug: 'today' },
  { i18nKey: 'common:periods.tomorrow', value: 'TOMORROW', slug: 'tomorrow' },
  {
    i18nKey: 'common:periods.thisWeekend',
    value: 'THIS_WEEKEND',
    slug: 'this-weekend',
  },
  { i18nKey: 'common:periods.thisWeek', value: 'WEEK', slug: 'week' },
  {
    i18nKey: 'common:periods.nextWeek',
    value: 'NEXT_WEEK',
    slug: 'next-week',
  },
  { i18nKey: 'common:periods.thisMonth', value: 'MONTH', slug: 'month' },
  { i18nKey: 'common:periods.anytime', value: 'ANYTIME', slug: 'anytime' },
]

export function getPeriods(t = () => null) {
  return periods.map(item => ({
    name: t(item.i18nKey),
    value: item.value,
    slug: item.slug,
  }))
}
